<template>
  <div class="page" :class="bodyHide==1?'border-box overflow':''" v-wechat-title="$route.meta.title">

    <div class="main-scroll-view" style="position: relative; width: 100%; height: auto;">
      <!--顶图-->
      <div class="banner border-box">
        <img class="img" v-lazy="res.tvideourl" alt="">
      </div>

      <div class="article-info clearfix">
        <img class="fl article-tx" v-lazy="res.guideheadimg" alt="">
        <div class="fr article-right">
          <p class="name">{{res.guidename}}</p>
          <p class="date">{{res.time}}</p>
          <div class="article-like" :class="res.iszan==1?'curr':''" @click="articleZan">
            <img v-if="res.iszan==0" src="../../assets/city_icon11.png" alt="">
            <img v-if="res.iszan==1" src="../../assets/city_icon11_curr.png" alt="">
            {{res.zan}}
          </div>
        </div>
      </div>

      <div class="article-tit">{{res.name}}</div>
      <div class="article-num">{{res.listencount|initNumber}}阅读</div>

      <div class="article">
        <div v-html="res.content"></div>
      </div>

      <!--新增打赏-->
      <div class="ds-box border-box" @click="rewardShowFun">
        <div v-if="res.dsimgs && res.dsimgs.length>0">
          <img v-for="(item,index) in res.dsimgs"  class="img ds-box-img" v-lazy="item.rzimg?item.rzimg:item.img"/>
          <span class="ds-box-num">已有{{res.dsnum|initNumber}}人打赏</span>
        </div>
        <div v-if="!res.dsimgs||res.dsimgs.length==0">
          <span class="ds-box-num">暂无打赏</span>
        </div>
        <span class="fr ds-box-btn">打赏</span>
      </div>

      <p class="split-line" style="margin-top: .34rem;height: .02rem;background: #f1f1f1;"></p>

      <!--新增评论头部-->
      <div class="comments-list-top clearfix border-box" id="comments-list-top">
        <span class="fl">游客点评</span>
      <span @click="commentShow=1" class="fr commentBtn">我要点评
        <img src="../../assets/icon-write.png" />
      </span>
      </div>

      <!--新增底部评论详情列表-->
      <div class="comments-list border-box account-list-sr">
        <div v-for="(item,index) in commentList" :key="index" class="comments-list-data box border-box">
          <p class="block head-img-box">
            <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg"/>
          </p>

          <div class="flex comments-list-info  border-box">
            <div class="comments-person-box box ">
              <div class="block comments-person">
                <p class="comments-person-name hide">{{item.name}}</p>
                <p class="star-level">
                  <template v-for="(star,index) in [2,4,6,8,10]">
                    <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                    <img v-else  src="../../assets/start_nor.png" />
                  </template>
                  <span class="icon-reward-small" v-if="item.isds&&res.noReward!=1">赏</span>
                </p>
              </div>
              <p @click="uploadZan(index)" class="praise">
                <span>{{item.totalZan}}</span>
                <img v-if="item.iszan==1" src="../../assets/zan_already.png" />
                <img v-else src="../../assets/zan_already_no.png" />
              </p>
            </div>

            <div class="comments-detail border-box">
              <p class="comments-detail-top">{{item.content}}</p>
            </div>

            <div v-if="item.allimg" class="comments-img box border-box">
              <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite" />
            </div>

            <div class="block comments-person-time">
              {{item.addtime}}
              <!--<span @click="replay" class="comments-person-hf fr" v-if="res.isguide && item.replys.length<1"><img src="../../assets/icon_play_btn11.png" />回复</span>-->
              <span v-if="item.state==2" class="shz-text fr none">审核中</span>
            </div>

            <div v-if="item.replys" class="comments-detail-replay border-box">
              <div v-for="(item,index) in item.replys" :key="index" class="comments-replay-text">
                <span>{{item.bagname}}</span> 回复
                <span>{{item.name}}</span> ：{{item.content}}
              </div>
            </div>
          </div>
        </div>
        <router-link :to="{path:'/comment',query: {id:this.$route.query.id,isbuy:res.isbuy,isguide:res.isguide, TimeStamp: TimeStamp, appKey: appKeyA}}">
          <div class="bottom-box border-box">
            <p class="select-more">查看共{{commentListLen}}条评论</p>
          </div>
        </router-link>

        <p class="load-tip" ref="loadtip" style="display: none;"></p>
      </div>
    </div>


    <!--新版本打赏弹窗8-20-->
    <AlertReward :bagInfo="bagInfo" :dsImgs="res.dsimgs" :class="{'curr':rewardShow==1,'none':rewardShow!=1}" @child-Reward="closeReward"></AlertReward>

    <!--新版本评论弹窗8-21-->
    <AlertComment :bagInfo="bagInfo" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex'
  import AlertReward from '../../components/AlertReward'
  import AlertComment from '../../components/AlertComment'
  import P400 from '../../components/P400'
  import {getBagComment, getZan, uploadUserBrowse,citySiteFoodDetail,citySiteFoodZan} from "@/service/getData";
  import {wxGetPosition,wxImgPreview, wxShareme,artRecord} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)


  var fromPath,fullPath;
  export default {
    data(){
      return{
        id: '', //文章id
        userInfo: {}, //用户信息
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey:'',
        appKeyA: '',
        res:{
          noReward: 1
        },//接口所有数据
        bagInfo:'',//文章详情与res相同，引用的组件里面需要
        commentList:[],//评论数据
        commentListLen:0,//评论条数
        commentShow:0,//评论弹窗
        rewardShow:0,//打赏弹窗
        bodyHide:0,//页面是否滚动
        isDs: false, //是否打赏过
        P400: 0, //系统维护中
      }
    },
    computed: {

    },
    created() {
      this.id = this.$route.query.id;
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }


      this.$loading.show('数据加载中');
      this.initData();
      this.initComment();

      window.addEventListener("scroll",function(){})
    },
    beforeDestroy(){
      window.removeEventListener("scroll",function(){});
    },

    mounted(){
      window.addEventListener('scroll', this.commentOffsetTop)//新增
    },
    methods: {
      async initData(){
        var self = this;
        this.userInfo = getStore("userInfo");
        let res = await citySiteFoodDetail({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: this.id
        });
        if (res.errcode == "00000"){
          this.$loading.hide();
          console.log(res);
          this.res = res.data;

          this.bagInfo = res.data;
          setStore("bagInfo",this.bagInfo);
          this.$route.meta.title = this.res.name;
          var share = res.data.share;
          let link = 'city-article?id=' + this.id + '&TimeStamp=' + this.TimeStamp + '&appKey=' + this.appKey;
          if(share == null){
            let title = '说美食';
            let desc = '讲人文 . 听趣史 . 说美食 . 游景区';
            let img = this.res.tvideourl ? this.res.tvideourl : this.bagInfo.guideheadimg;
            var bid = this.id;
            wxShareme(title,desc,img,link,function(){
              artRecord(bid);
            });
          }else {
            wxShareme(share.title,share.desc,share.logo,link,function(){
              artRecord(bid);
            });
          }

        }else {
          this.$loading.hide();
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //文章点赞
      async articleZan(){
        let res = await citySiteFoodZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id
        });
        if(res.errcode == "00000"){
          this.res.zan++;
          this.res.iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },



      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      async initComment(){
        let res = await getBagComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: 1,
          rows: 5,
          bagid: this.id,
        });

        if (res.errcode === "00000"){
          if (res.data.root.length > 0) {
            this.commentList = res.data.root;
            this.commentListLen = res.data.total;
          }
        }
      },

      //页面滑动到指定标签id位置
      scollToComment(elmid,top){
        MtaH5.clickStat("video_play_icon_comment");
        let self = this;
        self.$nextTick(function() {
          var dom = document.getElementById(elmid);
          if(dom && dom != null){
            if(top){
              window.scrollTo(0,Number(self.offSet(dom)+top));
            }else {
              window.scrollTo(0,self.offSet(dom));
            }
          }
        });
      },

      offSet(curEle){
        var totalTop = null;
        var par = curEle.offsetParent;
        //首先把自己本身的相加
        totalTop += curEle.offsetTop;
        //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
        while (par){
          //把父级参照物的偏移相加
          totalTop += par.offsetTop;
          par = par.offsetParent;
        }
        return totalTop;
      },

      //打赏弹窗显示隐藏
      rewardShowFun(){
        MtaH5.clickStat("video_play_reward");
        this.rewardShow = 1;
      },
      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.initComment();
        }
      },
      //打赏弹窗隐藏
      closeReward :function(msg){
        this.rewardShow = msg.rewardShow;
        if(msg.success){
          this.bagInfo.dsnum++;
        }
      },


      //评论弹窗显示隐藏
      commentsShow(){
        this.commentShow = 1
      },


      //用户评论点赞
      async uploadZan(index){
        let res = await getZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          commentid: this.commentList[index].id
        });
        if(res.errcode == "00000"){
          this.commentList[index].totalZan++;
          this.commentList[index].iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },


    },
    watch:  { },
    components: {
        AlertReward,
        AlertComment,
        wxConfirm,
        P400
    },
    //格式化数据
    filters: {
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      }
    },

    destroyed () {//新增离开该页面需要移除监听评论距离顶部距离属性
      window.removeEventListener('scroll', this.commentOffsetTop)
    },
  }

</script>

<style scoped>
  @import '../../style/alert.css';
  .page{padding-bottom:0; background-color: #fff; }

  /* banner */
  .banner{position:relative;height:3rem;border-radius:.07rem}

  .article-info{padding: 0 .28rem;margin-top: .15rem;}
  .article-tx{width: .9rem;height: .9rem;border-radius: 50%; object-fit: cover; }
  .article-right{position:relative;width: calc(100vw - 1.66rem);height: .9rem;margin-left: .2rem;}
  .article-right .name{margin-top: .2rem;font-size: .24rem;color: #84b8fc;}
  .article-right .date{margin-top: .08rem;font-size: .16rem;color: #999;}
  .article-like{position: absolute;right: 0;top:50%;height: .5rem;padding: 0 .16rem;font: .24rem/.5rem "Microsoft YaHei";color:#f23e6c;background:none;border:1px solid #f23e6c;border-radius:.3rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .article-like.curr{color: #fff;background: #f23e6c;}
  .article-like img{float: left;width: auto;height: .24rem;margin-top: .13rem;margin-right: .14rem;}
  .article-tit{padding: 0 .28rem;margin-top: .48rem;font-size: .36rem;color: #0b0b0b;}
  .article-num{padding: 0 .28rem;margin-top: .2rem;font-size: .18rem;color: #777;}

  .article{padding: 0 .28rem .4rem;margin-top: .64rem;font: .24rem/.36rem "Microsoft YaHei";color: #777;}

  /*打赏*/
  .ds-box{height: .9rem;margin: .2rem .28rem 0;padding-left:.22rem;padding-right:.22rem;border-radius: .5rem;box-shadow: 0 0 0.25rem #f1f1f1;}
  .ds-box-img{float: left;width: .6rem;height: .6rem;margin-left:-.06rem;margin-top:.15rem;border-radius: 50%;object-fit: cover;}
  .ds-box-img:first-child{margin-left: 0;}
  .ds-box-img:nth-of-type(n+4){display: none;}
  .ds-box-num{float: left;margin-left: .22rem;font: .24rem/.9rem "Microsoft YaHei";color: #676767;}
  .ds-box-btn{width: .7rem;height: .7rem;text-align: center;margin-top: .1rem;font: .22rem/.7rem "Microsoft YaHei";color: #fff;border-radius: 50%;background: #ffc53f;}

  /*新增标题样式*/
  .list-tit-new{position:relative;padding: .24rem .18rem .4rem;line-height: .4rem;font: bold .32rem/.4rem "Microsoft YaHei";color: #333;}
  .list-tit-new span{float: left;}
  .list-tit-new span:nth-of-type(2){ display: inline-block;height: .32rem;padding: 0 .08rem;margin-left: .08rem;margin-top: .04rem;border-radius: .3rem;background: #39affa;font: .18rem/.32rem "Microsoft YaHei";color: #fefefe;}
  .list-tit-new .museum_icon{position: absolute;top:50%;right:.34rem;width: auto;height: .6rem;margin-top: -.3rem;}


  /*新增底部评论详情列表*/
  .comments-list{width:100%;padding:.36rem 0  .16rem .24rem; margin-bottom: 0; }
  .comments-list-top{width:100%;height:.88rem;padding:0 .22rem;margin-top: .4rem;border-bottom:1px solid #F0F0F0;}
  .comments-list-top .fl{font:bold .32rem/.88rem "Microsoft YaHei";color:#333;}
  .comments-list-top .fr{font:.28rem/.88rem "Microsoft YaHei";color:#666;}
  .comments-list-top .fr img{float:right;width:.29rem;height:.32rem;margin:.28rem 0 0 .16rem;}
  .comments-list .bottom-box{position:relative;width:100%;height:.88rem;background:#fff;}
  .select-more{height:.88rem;line-height:.88rem;font-size:.30rem;color:#faaf39;text-align:center;background: none;}
  .icon-reward-small{float:left;height:.26rem;line-height:.26rem;margin-top:-.03rem;margin-left:.05rem;padding:0 .10rem;font-size:.16rem;color:#fff;background:#f5681b;border-radius:.05rem;}
  .shz-text{margin-right:.24rem;color:#ff5400;font-size:.24rem;}



</style>



// WEBPACK FOOTER //
// src/page/city-site/city-article.vue